import router from './router'
import store from './store'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css' // progress bar style
import { Route } from 'vue-router'
import { getUserInfo } from '././utils/user'
import request from './utils/request'
NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['/', '/login', '/404', '/401'] // no redirect whitelist,白名单，无需登录可以访问
const _import = require('./import-' + process.env.NODE_ENV)
// 是否拥有权限判断
function hasPermission(to: Route) {
  if (to.path === '/' || to.path === '') {
    return true
  }
  // 可以在路由下的meta配置roles数组存放要求角色
  if (to.meta && to.meta.roles && to.meta.roles.length > 0) {
    let roles: Array<string> = to.meta.roles
    let userRoles = store.getters.roles
    if (!roles.some(role => userRoles.indexOf(role) > -1)) {
      //路由上配置了角色权限的话验证权限角色权限
      return false
    }
  }
  // meta配置type:'menu',代表此路由添加到了菜单配置权限中
  if (to.meta && to.meta.type == 'menu') {
    //验证此路由路径是否已经在授权菜单对应的路径下
    var paths: Array<String> = store.getters.paths
    return paths.some(item => item.split('?')[0] === to.path.split('?')[0])
  }
  return true
}

